<template>
  <div>
    <div v-if="!pageLoading">
      <back-nav to="CoverSummary" />
      <top-card current="BranchSelections" :cover="coverType.covertypeId" :amount="coverType.riskPremDto.totalPremium">Please select your preferred service branch</top-card>
      <v-card flat class="tw-mt-5 md:tw-mt-16 tw-py-1 md:tw-py-1">
        <v-form v-model="isValid">
          <div class="tw-px-4 md:tw-px-12 tw-mt-4 md:tw-mt-10">
            <div class="tw-w-full">
              <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 ">You can now choose your ideal branch to handle your business</h3>
              <hr class="tw-mt-3 tw-mb-5">
            </div>
            <v-radio-group v-model="branchCode" v-if="!branchesLoading" :rules="[v => !!v || 'Branch is required']">
              <div class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-px-2 md:tw-px-8">
                <v-radio v-for="(branch, $index) in branches" :key="$index" :value="branch.code" class="tw-px-2 md:tw-px-5 tw-mt-3 md:tw-mt-6">
                  <template #label>
                    <ul class="list-none">
                      <li>{{ branch.name }}</li>
                      <li class="tw-mt-1"><span class="c-blue-text">{{ branch.address }}</span></li>
                      <li>Open:{{ branch.openingTime }} Close:{{ branch.closingTime }}</li>
                      <li><span class="c-blue-text">{{ branch.tel }}</span></li>
                    </ul>
                  </template>
                </v-radio>
              </div>
            </v-radio-group>
            <div v-else class="tw-w-full tw-flex tw-justify-center">
              <v-progress-circular
                  :size="80"
                  color="primary1"
                  indeterminate
              ></v-progress-circular>
            </div>

            <div>
              <div class="tw-w-full tw-mt-4 md:tw-mt-10 tw-px-2 md:tw-px-10">
                <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg">You will receive a digital certificate on your email after payment. If you would like  physical certificate please select the branch you want to collect it from</h3>
                <v-radio-group class="my-2 tw-px-0 md:tw-px-6" v-model="selectBranch" :rules="[v => !!v || 'Selection choice is required']" row>
                  <v-radio label="Digital Certificate" :value="1" class="tw-mt-0 md:tw-mt-5 tw-pr-10"></v-radio>
                  <v-radio label="Pick up location" :value="2" class="tw-mt-3 md:tw-mt-5"></v-radio>
                </v-radio-group>
              </div>
            </div>

            <div v-if="selectBranch === 2">
              <div class="tw-w-full tw-mt-4 md:tw-mt-10">
                <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8">Where would you like to pick the certificate?</h3>
                <hr class="tw-mt-3 tw-mb-5">
              </div>
              <v-row class="tw-px-2 md:tw-px-8 lg:tw-px-16">
                <p class="tw-w-full">Choose Date and Time*</p>
                <v-col cols="12" sm="6">
                  <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="computedDateFormatted"
                          label="Date"
                          persistent-hint
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          class="tw-px-4"
                          :rules="[required('Date')]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="date"
                        no-title
                        @input="menu = false"
                        :min="new Date().toISOString().substr(0, 10)"
                        :allowed-dates="allowedDates"
                        color="primary"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-menu
                      ref="menu"
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="time"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="time"
                          label="Time"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          class="tw-px-4"
                          :rules="[required('Time')]"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                        ampm-in-title
                        v-if="menu2"
                        v-model="time"
                        full-width
                        @click:minute="$refs.menu.save(time)"
                        :allowed-hours="allowedHours"
                    ></v-time-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-radio-group v-model="branchCode1" v-if="!branchesLoading" :rules="[v => !!v || 'Pick up Location is required']">
                <div class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-px-2 md:tw-px-8">
                  <v-radio v-for="(branch, $index) in branches" :key="$index" :value="branch.code" class="tw-px-2 md:tw-px-5 tw-mt-3 md:tw-mt-6">
                    <template #label>
                      <ul class="list-none">
                        <li>{{ branch.name }}</li>
                        <li class="tw-mt-1"><span class="c-blue-text">{{ branch.address }}</span></li>
                        <li>Open:{{ branch.openingTime }} Close:{{ branch.closingTime }}</li>
                        <li><span class="c-blue-text">{{ branch.tel }}</span></li>
                      </ul>
                    </template>
                  </v-radio>
                </div>
              </v-radio-group>
            </div>

            <div v-if="coverType.covertypeId === 101" class="tw-px-4 md:tw-px-12 tw-mt-0 md:tw-mt-4">
              <v-checkbox v-model="checked1" :rules="[check()]">
                <template #label>
                  <p class="c-gray-text">I understand that, for Comprehensive Cover I will receive only one month cover pending valuation and internal risk assessment.</p>
                </template>
              </v-checkbox>
            </div>
            <div v-if="coverType.covertypeId === 101" class="tw-px-4 md:tw-px-12 tw-mt-0 md:tw-mt-4">
              <v-checkbox v-model="checked1" :rules="[check()]">
                <template #label>
                  <p class="c-gray-text">I agree to inspect my car within 14 days from the day of collection of insurance certificate. If I fail to do so, my comprehensive policy plan will be downgraded to third party policy plan</p>
                </template>
              </v-checkbox>
            </div>
            <div class="tw-px-4 md:tw-px-12 tw-mt-0">
              <v-checkbox v-model="checked" :rules="[check()]">
                <template #label>
                  <terms-and-conditions pre="I have" post="of the policy & I agree to the same" />
                </template>
              </v-checkbox>
            </div>

            <v-card-actions class="col-sm-6 offset-sm-3 tw-mt-5 md:tw-mt-8 tw-pb-8">
              <v-btn block large
                     color="secondary"
                     class="my-3 "
                     :loading="loading"
                     :disabled="!isValid"
                     @click="proceed">
                {{ isValid ? 'Proceed To Payment' : 'Check if all fields are filled' }}
              </v-btn>
            </v-card-actions>
          </div>
        </v-form>
      </v-card>
    </div>
    <div v-else class="tw-w-full tw-flex tw-justify-center">
      <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import TopCard from '@/components/buy/TopCard';
import TermsAndConditions from '@/components/TermsAndConditions';
import BackNav from '@/components/buy/BackNav';
import { mapGetters } from 'vuex';
import axios from 'axios';
import validations from '@/utils/validations';
import { changeFormat, formatDate, reverseFormat } from '@/utils/time';
import { FB_BUY_PICKUP_LOCATION } from '@/utils/const';

export default {
  name: 'BranchSelections',
  components: { BackNav, TermsAndConditions, TopCard },
  data() {
    return {
      loading: false,
      pageLoading: true,
      branchesLoading: true,
      branches: [],
      isValid: false,
      ...validations,
      branchCode: '',
      branchCode1: '189',
      checked: '',
      checked1: '',
      date: '',
      menu: false,
      time: null,
      menu2: false,
      quote: '',
      benefit: '',
      selectBranch: 0,
    };
  },
  watch: {
    selectBranch(val) {
      if (val === 1) {
        this.branchCode1 = '189';
      }
    },
  },
  computed: {
    ...mapGetters('rfq', ['getQoute']),
    coverType() {
      return this.getQoute !== {} ? this.getQoute.covertypes.find((e) => e.riskId === this.benefit) || this.getQoute.covertypes.find((e) => e.selected === 'Y') : {};
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  mounted() {
    const quote = this.$route.query.q;
    this.benefit = parseInt(this.$route.query.b, 10);
    this.quote = quote;
    this.$store.dispatch('rfq/getQuotation', quote).then(() => {
      if ('mainBranchCode' in this.getQoute) this.branchCode = parseInt(this.getQoute.mainBranchCode, 10);
      if ('branch' in this.getQoute) {
        this.checked = true;
        this.checked1 = true;
        const { branch } = this.getQoute;
        this.branchCode1 = parseInt(branch.code, 10);
        this.time = branch.pickupTime;
        this.date = branch.pickupDate !== '' ? new Date(this.reverseFormat(branch.pickupDate.replace('-', '/'))).toISOString().substr(0, 10) : '';
      }
      this.pageLoading = false;
    });
    this.getBranches();
  },
  methods: {
    async proceed() {
      this.loading = true;
      const {
        engineNumber, entertainmentSysValue, windscreenValue, ...carData
      } = {
        ...this.coverType.car,
        ...{
          carId: 0,
          benefits: [],
          covertypeId: this.coverType.covertypeId,
          evaluationSelected: 2131362803,
          riskId: parseInt(this.benefit, 10),
          vehicleImages: [],
          engineNo: this.coverType.car.engineNumber,
          valueOfEntertainmentScreen: this.coverType.car.entertainmentSysValue,
          valueOfWindScreen: this.coverType.car.windscreenValue,
        },
      };
      const data = {
        addressLine1: '1245',
        bankAccount: this.getQoute.client.bankAccount,
        bankBranch: this.getQoute.client.bankBranch,
        bankName: this.getQoute.client.bankName,
        coverFrom: this.changeFormat(this.getQoute.coverFrom),
        dateFormat: 'dd/MM/yyyy',
        documents: this.getQoute.document,
        email: this.getQoute.client.email,
        fullName: this.getQoute.client.fullName,
        idNumber: this.getQoute.client.idNumber,
        kraPinNumber: this.getQoute.client.kraPinNumber,
        mobileNumber: this.getQoute.client.mobileNumber,
        pinNumber: this.getQoute.client.kraPinNumber,
        poBoxNo: this.getQoute.client.poBoxNo,
        postalCode: this.getQoute.client.postalCode,
        gender: this.getQoute.client.gender,
        carDTOS: [carData],
        // prodId: this.coverType.productCode,
        prodId: 3437,
        quoteId: parseInt(this.quote, 10),
        selectedRiskId: parseInt(this.benefit, 10),
        paymentStatus: false,
        dlImage: {
          dlImageId: 0,
          backImageUrl: '',
          frontImageUrl: '',
        },
        premium: this.coverType.riskPremDto.totalPremium,
        privateCover: false,
        planChanged: false,
        paymentType: 'MONTHLY',
        addressLine2: this.getQoute.client.postalCode,
        coverTypeID: this.coverType.covertypeId,
        status: 0,
        timestamp: 0,
        branchCode: this.branchCode,
      };

      const branch = this.branches.find((e) => e.code === parseInt(this.branchCode1, 10));
      const locationData = {
        batchId: 0,
        branchAddress: branch.address,
        branchClosingTime: branch.closingTime,
        branchCode: branch.code,
        branchLatitude: branch.latitude,
        branchLongitude: branch.longitude,
        branchName: branch.name,
        branchOpeningTime: branch.openingTime,
        branchShortDescription: branch.shortDescription,
        branchTel: branch.tel,
        pickupDate: this.date !== '' ? this.formatDate(this.date).replace('/', '-') : '',
        pickupLocation: branch.name,
        pickupTime: this.time,
        quoteId: parseInt(this.quote, 10),
      };
      await axios.post('customer/quotation/policy/create', data)
        .then(async (response) => {
          if (response.data.success) {
            await axios.post('/customer/quotation/policy/update/pickup-location', locationData)
              .then(() => {
                this.$toast.success('Pick Up Location successfully set');
              });
            this.$toast.success('Branches selected successfully', 'Selections');
            this.$analytics.logEvent(FB_BUY_PICKUP_LOCATION);
            this.$emit('to-payment-selection');
          } else {
            this.$toast.error('An Error occurred, try again !', 'Selections');
          }
          this.loading = false;
        });
    },
    getBranches() {
      axios.get('/customer/gis/branches/retrieveAll')
        .then((response) => {
          this.branches = response.data.object;
          this.branchesLoading = false;
        });
    },
    changeFormat,
    formatDate,
    reverseFormat,
    allowedDates: (val) => ![0, 6].includes(new Date(val).getDay()),
    allowedHours: (val) => ![0, 1, 2, 3, 4, 5, 6, 7, 18, 19, 20, 21, 22, 23, 24].includes(val),
  },
};
</script>
